import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges, Output, EventEmitter, ElementRef } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { SolarService } from '../../services/solarservice.service';
import { MessageError } from 'base-models';
import { AlertType, NotificationType } from 'base-models';
import { Supervision, Flight, SupervisionStatusEnum, FlightStatusEnum } from 'solar-bo';
import { FlightEditComponent } from '../flight-edit/flight-edit.component';
import { FlightUploadComponent } from '../flight-upload/flight-upload.component';
import { DialogdeleteComponent } from 'basecomponents';

import { ErrorcontrolService } from 'basecomponents';

import { FlightBaseComponent } from '../flight-helper.component';
import * as moment from 'moment'
import { SortHelper } from 'shtools';
import { UploadInfo, UploadTypeEnum } from 'guploadmgr';


@Component({
  selector: 'app-flight-list',
  templateUrl: './flight-list.component.html',
  styleUrls: ['./flight-list.component.scss']
})
export class FlightListComponent extends FlightBaseComponent implements OnInit, OnChanges {

  @Input() supervision: Supervision;
  @Output() showFlightImagesItemEvent = new EventEmitter();
  @Output() flightSelectedEvent = new EventEmitter<any>();
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;


  displayedColumns = ['name', 'creation_date','status','relativealt','modifydate','actions'];
  dataSource = new MatTableDataSource<any>(this.listOriginal);
  filteredList: any;

  public constructor(protected solarService:SolarService,private elementRef: ElementRef) {
    super();
  }

  ngOnInit() {
    this.getList();
    
  }

  ngOnChanges(changes: SimpleChanges) {
    let typeChange = changes['supervision'];
    if (typeChange && !typeChange.firstChange && typeChange.previousValue == undefined) {
      if (!this.supervision) {
        return;
      }
      else{
        //this.configureRefreshFlightData();
      }
      this.getList();
    }
  }

  refresh() {
    this.getList();
  }

  table_showHideColumn(column:string,colIndex:number){
    let existCol=this.displayedColumns.findIndex(elem=>elem==column);
    if (existCol!=-1){
      this.displayedColumns.splice(existCol,1);
    }
    else{
      this.displayedColumns.splice(colIndex,0,column);
    }
  }

  refreshSupervisionDatainterval: any;
  configureRefreshFlightData() {

    if (!this.supervision || this.supervision.info.status==SupervisionStatusEnum.VALIDATED){
      return;
    }
    if(this.refreshSupervisionDatainterval) {
      clearInterval(this.refreshSupervisionDatainterval);
    }
    this.refreshSupervisionDatainterval = setInterval(() => {
      this.refreshFlightList();
    }, 5000);
  }

  refreshFlightList() {
    //console.log("Refreshing data");
    const element = this.elementRef.nativeElement;
    if(element.offsetParent === null) {
      // element is not visible
      
      return;
    }
    
    if (!this.supervision) {
      return;
    }
    this.solarService.supervisionGetFlights(this.supervision.id)
    .subscribe(
      reslist => this.getListhandleresult(reslist)
      , err => this.getListhandleError(err)
    );
  }

  getList(): void {
    if (!this.supervision) {
      return;
    }
    this.listerrmessage = "";
    this.loading = true;

    this.solarService.supervisionGetFlights(this.supervision.id)
      .subscribe(
        reslist => this.getListhandleresult(reslist)
        , err => this.getListhandleError(err)
      );
  }

  private getListhandleresult(newlist: any[]) {
    console.log('getListhandleresult', newlist);
    this.listerrmessage = '';
    this.loading = false;
    this.listOriginal = newlist;
    this.configsource();
    this.alertmessage = null;
  }
  private getListhandleError<T>(err: any) {
    console.log("getListhandleError");
    this.loading = false;
    this.alertmessage = ErrorcontrolService.basichandleError("", err);
  }

  configsource() {
    this.listOriginal=SortHelper.sortMultiple(this.listOriginal, ["info.creation_date"],["asc"]);
    this.dataSource = new MatTableDataSource<any>(this.listOriginal);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  /**
   * Raise event to indicate master parent to load flight images in new tab
   * @param item 
   */
  showFlightImages(item: Flight) {
    this.showFlightImagesItemEvent.next(item);
  }
  /**
   * Edit flight
   * @param itemToEdit 
   */
  editFlight(itemToEdit?: Flight) {
    this.newFlight(itemToEdit);
  }
  /**
   * Create or edit flight
   * @param itemToEdit pass null if new
   */
  newFlight(itemToEdit?: Flight) {
    let dialogRef: MatDialogRef<FlightEditComponent>;
    if (itemToEdit == null) {
      itemToEdit = new Flight();
      itemToEdit.name="Flight " + moment(new Date()).format("MM-DD-YYYY");
      itemToEdit.id_supervision = this.supervision.id;
    }
    dialogRef = FlightEditComponent.openModalWithModel(this.dialog, itemToEdit);
    dialogRef.componentInstance.saveEvent.subscribe((elem) => this.saveFlightEventHandler(dialogRef, itemToEdit, elem));
  }

  saveFlightEventHandler(dialogRef: MatDialogRef<any>, itemToEdit: Flight, newFlight: Flight) {
    const index = this.listOriginal.findIndex(d => d.id === newFlight.id);
    if (index != -1) {
      this.listOriginal[index] = newFlight;
      this.configsource();
    } else {
      this.listOriginal.push(newFlight);
      this.configsource();
    }
    //console.log("saveModelEvent list", newFlight);
    if (dialogRef != null) {
      dialogRef.close();
    }
  }

  openDialogAddFilesToFlight(row: Flight) {
    let dialogRef: MatDialogRef<FlightUploadComponent>;

    let uploadinfo: UploadInfo = new UploadInfo();
    uploadinfo.parentid = row.id;
    uploadinfo.parentname = row.name;
    uploadinfo.id = row.id;
    uploadinfo.upload_type = UploadTypeEnum.flight;

    dialogRef = FlightUploadComponent.openModalWithModel(this.dialog, row, uploadinfo);
  }

  openDialogDeleteFlight(model) {

    let dialogRef = this.openDialogDelete("Delete Flight", "Do you want to delete flight: " + model.name, model);
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => this.deleteFlightHandler(model, dialogRef));
  }

  deleteFlightHandler(model: Flight, dialogRef: MatDialogRef<DialogdeleteComponent>, ) {
    console.log("deleteFlightHandler" + model.name);
    const dlgComp = dialogRef.componentInstance;
    dlgComp.lockdeletebtn();
    //dlgComp.addmessage("error","No se ha podido borrar el site");
    dialogRef.close();
    this.loadinglist = true;
    this.alertmessage = new MessageError(AlertType.Warning, "Deleting Flight, please wait");
    this.solarService.flightDeleteById(model.id).subscribe(() => this.flightDeleteSuccessHandler(model.id), err => this.handleError(err, "Error deleting Flight "));
  }

  flightDeleteSuccessHandler(id: string) {
    const index = this.listOriginal.findIndex(el => el.id == id, 0);
    if (index > -1) {
      this.listOriginal.splice(index, 1);
      this.configsource();
    }
    this.loadinglist = false;
    this.alertmessage = new MessageError(AlertType.Success, "Flight deleted");
  }
  /**
   * Process all flights for supervision
   */
  supervisionProcessFlights() {
    let dialogRef = this.openDialogQuestion("Process Flights", "Do you want to process all flight images");
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => {
      dialogRef.close();
      let model:Supervision=this.supervision;
      this.loadinglist = true;
      this.alertmessage = new MessageError(AlertType.Warning, "Starting processing files, please wait");
      
      this.solarService.supervisionProcessFlights(model.id).subscribe(() => this.processFlightSuccessHandler(model), err => this.handleError(err, "Error processing Flight: "));
    });
  }  

  /**
   * Process images uploaded before
   * @param model 
   */
  processFlight(model: Flight) {
    let dialogRef = this.openDialogQuestion("Process Flight", "Do you want to process flight images for </b>" + model.name +"</b>", model);
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => {
      dialogRef.close();
      this.loadinglist = true;
      this.alertmessage = new MessageError(AlertType.Warning, "Processing files for flight, please wait");
      this.solarService.flightProcess(model).subscribe(() => this.processFlightSuccessHandler(model), err => this.handleError(err, "Error processing Flight: "));      
    });    

  }

  private processFlightSuccessHandler(model) {
    this.alertmessage=null;
    this.showNotification(NotificationType.Info,"Flight process started");
    model.info.status=FlightStatusEnum.FLIGHT_FILE_PROCESSING;
    this.supervision.info.status=SupervisionStatusEnum.INPROCESS;
    this.loadinglist=false;
  }
  /**
   * Find issues for all flights for supervision
   */
  supervisionFindIssues() {
    let model:Supervision=this.supervision;
    let dialogRef = this.openDialogQuestion("Find Issues on Flights", "Do you want to find issues for this supervision?</b><br><br><b>This action will overwrite actual issues.</b>");
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => {
      dialogRef.close();      
      this.loadinglist = true;
      this.alertmessage = new MessageError(AlertType.Warning, "Starting finding issues for flight, please wait");
      this.solarService.supervisionFindIssues(model.id).subscribe(() => this.processFlightSuccessHandler(model), err => this.handleError(err, "Error processing Flight: "));
    });
 }

  /**
   * Find issues for selected flight
   * @param model 
   */
  flightFindIssues(model: Flight) {
    let msg= "Do you want to find issues for selected flight: <b>" + model.name + "</b><br><br><b>This action will overwrite actual issues.</b>";
    let dialogRef = this.openDialogQuestion("Find issues for flight",msg, model );
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => 
      {this.loadinglist = true;
      this.alertmessage = new MessageError(AlertType.Warning, "Starting finding issues for flight, please wait");
       this.solarService.flightFindIssues(model).subscribe(
        () => this.flightFindIssuesSuccessHandler(model)
        , err => this.handleError(err, "Error processing Flight: ")
        ); 
      dialogRef.close();
      }
    );
  }

  private flightFindIssuesSuccessHandler(model:Flight) {
    this.alertmessage=null;
    this.showNotification(NotificationType.Info,"Flight process started");
    model.info.status=FlightStatusEnum.FLIGHT_FILE_PROCESSING;
    this.supervision.info.status=SupervisionStatusEnum.INPROCESS;
    this.loadinglist=false;
  }


    /**
   * Process images uploaded before
   * @param model 
   */
  projectFlightImages(model: Flight) {
    let dialogRef = this.openDialogQuestion("Project flight images", "Do you want to project flight images </b>" + model.name +"</b>", model);
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => {
      dialogRef.close();
      this.loadinglist = true;
      this.alertmessage = new MessageError(AlertType.Warning, "Projecting images for flight, please wait");
      this.solarService.flightProjectImages(model)
      .subscribe(() => 
      {
        this.alertmessage=null;
        this.showNotification(NotificationType.Info,"Flight project process started");
        model.info.status=FlightStatusEnum.FLIGHT_FILE_PROCESSING;
        this.supervision.info.status=SupervisionStatusEnum.INPROCESS;
        this.loadinglist=false;
      }

      , err => this.handleError(err, "Error projecting flight: "));      
    });    

  }

  showFlight(flight:Flight){
    let isSelected=this.flightSelectedList.find(item=>item.id==flight.id);
    if (!isSelected){
      let color=this.getRandomColor();
      isSelected={id:flight.id,selected:true, flight:flight, color:color};
      this.flightSelectedList.push(isSelected);
    }
    else{
      isSelected.selected=!isSelected.selected;
    }
    this.flightSelectedEvent.emit(isSelected);
    //this.showNotificationInfo("This operation is under development. Clicking on any flight will be show the flight on the map.");
  }
  flightSelectedList:{id:any,selected:boolean, flight:Flight, color:any}[]=[];
  flightIsSelected(flight:Flight){
    let isSelected=this.flightSelectedList.find(item=>item.id==flight.id);
    if (isSelected && isSelected.selected==true){
      return true;
    }
    else{
      return false;
    }
  }
  flightColor(flight:Flight){
    let isSelected=this.flightSelectedList.find(item=>item.id==flight.id);
    if (isSelected){
      return isSelected.color;
    }
    else{
      return "#00000000";
    }
  } 

/*   private flightLayersColors:any[]=[];
  private flightSetColor(key:any){
    let color=this.getRandomColor();
    this.flightLayersColors.push({id:key,color:color});
    return color;
  } */

  private getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }
  

}

